import React from "react";
import { SelectCard, BackButton } from './../../components/index'
import locksIcon from './../../assets/svg/locks.svg'
import peripheralsIcon from './../../assets/svg/peripherals.svg'


export default function Firmware() {
  return (
    <div className="firmware">
      <BackButton />
      <h2>Select an Option</h2>
      <div className="cards">
        <SelectCard 
          img={locksIcon}
          title="Locks & Cylinders"
          url="/firmware/locks"
          />
        <SelectCard 
          img={peripheralsIcon}
          title="Peripherals"
          url="/firmware/peripherals"
        />
      </div>
    </div>
    
  )
}